import { CHANGE_USER_PROFILE_REQUEST, CHANGE_USER_PROFILE_SUCCESS, CHANGE_USER_PROFILE_FAILURE } from '../../constants/user_profile.constants';

const prefix = 'CHANGE'; const
    item = 'PROFILE';
export const changeUserProfileRequest = params => ({
    type: CHANGE_USER_PROFILE_REQUEST,
    params,
    prefix,
    item,
});

export const changeUserProfileRequestSuccess = profile => ({
    type: CHANGE_USER_PROFILE_SUCCESS,
    profile,
});

export const changeUserProfileRequestFailure = error => ({
    type: CHANGE_USER_PROFILE_FAILURE,
    error,
    prefix,
    item,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_profile_actions/change_user_profile.actions.js